import React, { useEffect } from 'react';
import { Button } from 'components/ui/button';
import { Megaphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const config = {
  selector: '.headwayapp-updates', // CSS selector where to inject the badge
  account: 'yjva9y',
};

export default function News() {
  const { t } = useTranslation();
  const translations = {
    title: t('headway.title'),
    readMore: t('headway.readMore'),
    labels: {
      new: t('headway.labels.new'),
      improvement: t('headway.labels.improvements'),
      fix: t('headway.labels.fix'),
    },
    footer: t('headway.footer'),
  };
  useEffect(() => {
    if (window.Headway) {
      window.Headway.init({ ...config, translations });
    }
    return () => {};
  }, []);

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={t('header.news')}
      title={t('header.news')}
      className="headwayapp-updates relative isolate"
    >
      <Megaphone aria-hidden="true" />
    </Button>
  );
}
